'use strict'

export const sanitize = (fieldConfigs, input) => {

	const contexts = makeTestContexts(fieldConfigs, input);

	return Object.fromEntries(
		Object.entries(contexts).map(
			([ fieldName, [ fieldConfig, value ]]) => [
				fieldName,
				fieldConfig ? fieldConfig.sanitize(value) : value,
			]
		)
	);
};

const makeTestContexts = (fieldConfigs, input) => Object.keys(input).reduce(
	(obj, k) => ({
		...obj,
		[ k ]: [ fieldConfigs[ k ], input[ k ] ],
	}),
	{}
);

const runTest = value => testObj => {

	if (testObj.test(value)) {
		return {
			success: true,
			message: '',
		};
	}

	return {
		success: false,
		message: testObj.message,
	};
};

export const runTests = (fieldConfigs, input) => {

	const contexts = makeTestContexts(fieldConfigs, input);

	return Object.entries(contexts).reduce(
		(reports, [ fieldName, [ fieldConfig, value ]]) => {

			if (fieldConfig) {
				const testResults = fieldConfig.tests.map(runTest(value));
				const success = !testsHaveError(testResults);

				return [
					...reports,
					[
						fieldName,
						{
							success,
							testResults,
						},
					]
				];
			}

			return reports;
		},
		[]
	);
};

const testsHaveError = fieldTestResults => fieldTestResults.reduce(
	(hasError, testResult) => {
		if (!hasError) {
			if (!testResult.success) {
				return true;
			}
		}
		return hasError;
	},
	false
);

export const hasError = report => report.reduce(
	(hasError, [ fieldName, fieldResult ]) => {
		if (!hasError) {
			if (!fieldResult.success) {
				return true;
			}
		}
		return hasError;
	},
	false
);

export const triggerErrors = (errorReporter, report) => report.forEach(
	([ field, fieldResult ]) => {
		if (!fieldResult.success) {
			errorReporter[ field ].affirmative(fieldResult.testResults);
		}
	}
);

export const triggerServerErrors = (errorReporter, report) => report.forEach(
	({ field, message }) => {
		errorReporter[ field ].affirmative([ { error: true, message } ]);
	}
);
